<template>
  <div class="common_tools">
    <ul class="tools_box">
      <!-- user avatar -->
      <li
        v-report:mainclick="{ area: 'account', pos: 0 }" title="用户" class="icon_item user_icon_box"
        @click="userLoginHandle">
        <span :class="`icon icon_user ${ userIconClass }`" />

        <DialogBox v-if="logoutVisible && isLoginedIn" key="1" class="msg_dialog">
          <ul class="user_list">
            <li v-show="!isVip" class="item" @click.stop="buyMember">成为会员</li>
            <li class="item" @click.stop="logout">注销登录</li>
          </ul>
        </DialogBox>

        <DialogBox key="2" color="blue" :class="`user_member_dialog ${ logoutVisible && 'logout_visible' }`">
          <p v-if="!isLoginedIn" class="info">您还没登陆</p>
          <p v-else-if="!userInfo.privliegeEndTime" class="info">您还不是会员</p>
          <p v-else class="info">{{ `会员于${ userInfo.privliegeEndTime }到期` }}</p>
        </DialogBox>
      </li>
      <!-- 页面重载 -->
      <li
        v-report:mainclick="{ area: 'refresh', pos: '' }" title="页面重载" class="icon_item"
        @click="clickReload"><span class="icon icon_reload" /></li>
      <!-- 设置 -->
      <li
        title="设置" class="icon_item" :class="{ active: settingListVisible }"
        @mousedown="settingListVisible = true">
        <span class="icon icon_setting" />
        <ul v-show="settingListVisible" class="setting_list">
          <li v-report:mainclick="{ area: 'set', pos: 0 }" class="setting_item" @click="settingVisible = true">设置</li>
          <li v-report:mainclick="{ area: 'set', pos: 1 }" class="setting_item" @click="clickOpenCustoreService">客服</li>
          <li v-report:mainclick="{ area: 'set', pos: 2 }" class="setting_item" @click="clickOpenFeedback">反馈</li>
        </ul>
      </li>
      <!-- 关闭页面 -->
      <li
        v-report:mainclick="{ area: 'close', pos: '' }" title="关闭" class="icon_item"
        @click="clickCloseWin"><span class="icon icon_close" /></li>
    </ul>

    <Dialog v-model="settingVisible" :title="'设置'"><ToolsSetting /></Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/Dialog/index.vue'
import ToolsSetting from './ToolsSetting.vue'
import DialogBox from './DialogBox.vue'

import {
  ClientOpenTabsByLogin, ClientCloseSidebar, ClientFeedback,
  ClientOpenBrowser, ClientCloseTable, ClientSetUserInfo,
  ClientOpenTabsByBuy
} from '@/api/clientApi.js'
import { UrlCustomer } from '@/common/resources.js'

export default {
  name: 'Tools',

  components: { Dialog, ToolsSetting, DialogBox },

  data () {
    return {
      settingListVisible: false,
      settingVisible: false,
      logoutVisible: false
    }
  },

  computed: {
    isLoginedIn () {
      return this.$store.getters.isLoginedIn
    },

    isVip () {
      return this.$store.getters.isVip
    },

    userInfo () {
      return this.$store.state.userInfo
    },

    userIconClass () {
      if (this.isLoginedIn) {
        return this.isVip ? 'vip' : 'login'
      }
      return ''
    }
  },

  mounted () {
    document.addEventListener('click', this.settingHandle)
  },

  destroyed () {
    document.removeEventListener('click', this.settingHandle)
  },

  methods: {
    clickReload () {
      location.reload()
    },

    settingHandle (e) {
      const className = e.target.className

      if (this.logoutVisible && !className.includes('icon_use')) {
        this.logoutVisible = false
      }

      if (this.settingListVisible && !className.includes('icon_setting')) {
        this.settingListVisible = false
      }
    },

    userLoginHandle () {
      if (this.isLoginedIn) {
        this.logoutVisible = true
        return
      }

      ClientOpenTabsByLogin()
    },

    clickCloseWin () { ClientCloseSidebar() },

    clickOpenFeedback () { ClientFeedback() },

    clickOpenCustoreService () { ClientOpenBrowser(UrlCustomer) },

    buyMember () {
      this.logoutVisible = false
      ClientOpenTabsByBuy()
    },

    logout () {
      this.logoutVisible = false
      this.$store.commit('vuexSetUserInfo', {})

      ClientCloseTable()
      ClientSetUserInfo({})
    }
  }
}
</script>

<style lang="scss" scoped>
.common_tools {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 45px;
  background-color: #fff;
  border-bottom: 1px solid $border_color;

  .tools_box { display: flex; align-items: center; height: 100%; margin-right: 12px;

    .icon_item {
      position: relative;
      width: 28px;
      height: 28px;
      cursor: pointer;
      border-radius: 4px;

      &:hover { background-color: #f3f3f6; }

      &.icon_item { margin-left: 16px; }

      .setting_list {
        position: absolute;
        top: 38px;
        left: -23px;
        z-index: 1;
        width: 76px;
        padding: 5px 0;
        font-size: 16px;
        font-weight: 400;
        color: $font_color_5;
        text-align: center;
        background-color: #fff;
        box-shadow: $box_shadow_2;

        .setting_item {
          height: 30px;
          line-height: 30px;

          &:hover { font-weight: bold; color: $font_color_8; background-color: #e0e2e9; }
        }
      }
    }
    .icon { display: inline-block; width: 100%; height: 100%; background-repeat: no-repeat; background-position: center center; background-size: 28px 28px; }
    .icon_user {
      background-image: url(~@/assets/images/icon_tools_user.svg);

      &.login { background-image: url(~@/assets/images/icon_tools_user_login.svg); }
      &.vip { background-image: url(~@/assets/images/icon_tools_user_vip.svg); }
    }
    .icon_reload { background-image: url(~@/assets/images/icon_tools_reload.svg); }
    .icon_setting { background-image: url(~@/assets/images/icon_tools_setting.svg); }
    .icon_close { background-image: url(~@/assets/images/icon_tools_close.svg); }

    .user_icon_box {
      &:hover { .user_member_dialog { display: block; } }

      .logout_visible { &.user_member_dialog { display: none !important; } }

      .msg_dialog {
        position: absolute;
        top: 38px;
        left: -18px;
        z-index: 1;

        .user_list {
          padding: 5px 0;
          font-size: 12px;
          font-weight: 400;
          line-height: 26px;
          text-align: center;

          .item { &:hover { color: #fff; background-color: $theme_color; } }
        }
      }

      .user_member_dialog {
        position: absolute;
        top: 38px;
        right: -13px;
        z-index: 1;
        display: none;

        .info { padding: 0 10px; font-size: 12px; font-weight: 400; line-height: 30px; color: #fff; text-align: center; white-space: nowrap; }
      }
    }
  }
}
</style>
